import {ReactElement} from "react";

// types
export type jsxConditionCallback = () => ReactElement<any>;

// funcs or classes

export function jsxIf(condition: any, callback: jsxConditionCallback): JsxConditionChain {
  let chain = new JsxConditionChain();
  if (condition) {
    chain.callback = callback;
  }
  return chain;
}

export class JsxConditionChain {
  callback: jsxConditionCallback;   // 条件通過時に実行するcallback

  jsxElseif(condition: any, callback: jsxConditionCallback) {
    // callback が設定されていればすでにこれまでの条件を通過しているので無視
    if (this.callback) {
      return this;
    }
    if (condition) {
      this.callback = callback;
    }
    return this;
  }

  jsxElse(callback: jsxConditionCallback) {
    if (this.callback) {
      return this;
    }
    this.callback = callback;
    return this;
  }

  endIf() {
    if (this.callback) {
      return this.callback();
    }
    return "";
  }
}
